var React = require('react');

function ArrowForwardInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.9987 9.3335L24.7087 12.6235L37.7287 25.6668H9.33203V30.3335H37.7287L24.7087 43.3768L27.9987 46.6668L46.6653 28.0002L27.9987 9.3335Z","fill":"currentColor"}));
}

ArrowForwardInline.defaultProps = {"width":"1.2em","height":"1.2em","viewBox":"0 0 56 56","fill":"none"};

module.exports = ArrowForwardInline;

ArrowForwardInline.default = ArrowForwardInline;
